import React, { useEffect, useRef } from "react";
import styled from "styled-components";

const BannerContainer = styled.div<{ position: "left" | "right" }>`
  position: fixed;
  top: 0; /* Collé tout en haut */
  ${(props) => (props.position === "left" ? "left: 20px;" : "right: 20px;")}
  z-index: 1000;
  @media (max-width: 768px) {
    display: none;
  }
`;

import { useState } from "react";

export const BannerSticky: React.FC<{ position: "left" | "right"; scriptKey: string }> = ({
  position,
  scriptKey,
}) => {
  // Tous les hooks doivent être appelés en haut du composant
  const [isClient, setIsClient] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [hiddenMobile, setHiddenMobile] = useState(false);
  const [mobileTimer, setMobileTimer] = useState<NodeJS.Timeout | null>(null);
  const [unhideTimer, setUnhideTimer] = useState<NodeJS.Timeout | null>(null);

  // Détection mobile simple (JS)
  const isMobile = () => typeof window !== "undefined" && window.innerWidth <= 768;

  useEffect(() => {
    setIsClient(true);
  }, []);

  // Gestion du masquage auto sur mobile
  useEffect(() => {
    if (typeof window === "undefined" || !isMobile()) return;
    // Timer pour masquer la pub après 3s si pas de clic
    const timer = setTimeout(() => {
      setHiddenMobile(true);
      // Timer pour réafficher après 1 min
      const unhide = setTimeout(() => setHiddenMobile(false), 60000);
      setUnhideTimer(unhide);
    }, 3000);
    setMobileTimer(timer);
    // Nettoyage
  }, [scriptKey]);

  // Calcul du rendu
  const shouldRender = isClient && typeof window !== "undefined" && window.innerWidth > 768;
  // Si mobile et pub masquée, ne rien afficher
  const shouldHideMobile = isMobile() && hiddenMobile;

  // Clique sur la pub = annule le masquage
  const handleAdClick = () => {
    if (!isMobile()) return;
    if (mobileTimer) clearTimeout(mobileTimer);
    if (unhideTimer) clearTimeout(unhideTimer);
  };

  useEffect(() => {
    if (!ref.current) return;
    // Do not inject on mobile to avoid intrusive behavior
    if (typeof window !== "undefined" && window.innerWidth <= 768) return;
    ref.current.innerHTML = "";
    let removed = false;
    // Script config
    const scriptConfig = document.createElement("script");
    scriptConfig.type = "text/javascript";
    scriptConfig.innerHTML = `
      atOptions = {
        'key' : '${scriptKey}',
        'format' : 'iframe',
        'height' : 600,
        'width' : 160,
        'params' : {}
      };
    `;
    // Script loader
    const scriptLoader = document.createElement("script");
    scriptLoader.type = "text/javascript";
    scriptLoader.src = `//www.highperformanceformat.com/${scriptKey}/invoke.js`;
    scriptLoader.async = true;
    // Gestion d'erreur
    scriptLoader.onerror = () => {
      if (ref.current) {
        ref.current.innerHTML = "";
        ref.current.style.display = "none";
        removed = true;
      }
      console.warn("[BannerSticky] Script pub non chargé (onerror)");
    };
    // Timeout de sécurité
    const timeout = setTimeout(() => {
      if (!removed && ref.current) {
        ref.current.innerHTML = "";
        ref.current.style.display = "none";
        console.warn("[BannerSticky] Script pub non chargé (timeout)");
      }
    }, 4000);
    ref.current.appendChild(scriptConfig);
    ref.current.appendChild(scriptLoader);
    return () => clearTimeout(timeout);
  }, [scriptKey]);

  // Le rendu principal
  return (
    <>
      {shouldRender && !shouldHideMobile && (
        <BannerContainer position={position} onClick={handleAdClick}>
          <div ref={ref} style={{ width: 160, height: 600 }} />
        </BannerContainer>
      )}
    </>
  );
};
